import _ from 'lodash';
import { ADMIN_USER_ROLE, TAG_TYPE } from '@/constants';

export default function() {
  const isNewMode = !!this.$route.params.id;
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'email',
      label: '邮箱',
      form: {
        component: 'input',
        required: true,
        props: {
          type: 'email'
        }
      }
    },
    {
      prop: 'sign_in_count',
      label: '登录次数',
      width: 80
    },
    {
      prop: 'current_sign_in_at',
      label: '本次登录时间',
      renderCell: 'time',
      sort: 'order_by'
    },
    {
      prop: 'last_sign_in_at',
      label: '上次登录时间',
      renderCell: 'time',
      sort: 'order_by'
    },
    {
      prop: 'created_at',
      label: '创建时间',
      renderCell: 'time',
      sort: 'order_by'
    },
    {
      prop: 'role',
      label: '角色',
      width: 150,
      renderCell(h, { row }) {
        return <el-tag type={TAG_TYPE[row.role]}>{ ADMIN_USER_ROLE[row.role] }</el-tag>;
      },
      form: {
        component: 'select',
        required: true,
        props: {
          defaultValue: 'super_admin',
          clearable: false,
          options: _.map(ADMIN_USER_ROLE, (label, value) => ({ label, value }))
        }
      }
    },
    {
      prop: 'password',
      label: '密码',
      action: ['hide-in-table', 'hide-in-detail'],
      form: {
        component: 'input',
        required: !isNewMode,
        props: {
          type: 'password',
          'show-password': true
        }
      }
    },
    {
      prop: 'password_confirmation',
      label: '重复输入密码',
      action: ['hide-in-table', 'hide-in-detail'],
      form: {
        component: 'input',
        required: !isNewMode,
        props: {
          type: 'password',
          'show-password': true
        }
      }
    }
  ];
}
